import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=f5c41912&scoped=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=f5c41912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c41912",
  null
  
)

export default component.exports